import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const ItensWeb = ({ listaItens, formatarValor, collapseFunctions, valorAdicional, valorTotalItens, valorTotalDescontosItens }) => {
    
    const { handleCollapse, collapsed } = collapseFunctions;

    return (
        <TableContainer> 
            <Table aria-label="spanning table">
                <TableHead>
                    <TableRow>
                        <TableCell colSpan={2} >Descrição</TableCell>
                        <TableCell align="right">Qtd.</TableCell>
                        <TableCell align="right">Valor Unitário</TableCell>
                        <TableCell align="right">Valor Desconto</TableCell>
                        <TableCell align="right">Valor Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        listaItens &&
                        listaItens.map(item => {
                            const titulo = item.TipoItemPedido_Id === 1 ? item.Descricao.split(' | ')[0] : item.Descricao;
                            const composicao = item.TipoItemPedido_Id === 1 ? item.Descricao.split(' | ')[1].split(';') : '';

                            return (
                                <React.Fragment key={item.ItemId}>
                                    <TableRow>
                                        <TableCell>
                                            {
                                                item.TipoItemPedido_Id === 1 &&
                                                    <IconButton aria-label="expand row" size="small" onClick={() => handleCollapse(item.ItemId)}>
                                                        { collapsed(item.ItemId) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> }
                                                    </IconButton>
                                            }
                                        </TableCell>
                                        <TableCell>{ titulo }</TableCell>
                                        <TableCell align="right">{ item.Quantidade }</TableCell>
                                        <TableCell align="right">{ formatarValor(item.PrecoUnitario) }</TableCell>
                                        <TableCell align="right">{ formatarValor(item.ValorDesconto) }</TableCell>
                                        <TableCell align="right">{ formatarValor(item.ValorLiquido) }
                                        </TableCell>
                                    </TableRow>
                                    {
                                        item.TipoItemPedido_Id === 1 &&
                                            <TableRow style={{ backgroundColor: '#FAFAFA' }}>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}></TableCell>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                                                    <Collapse in={collapsed(item.ItemId)} timeout="auto" unmountOnExit>
                                                        { composicao.map(comp => <Box margin={1} key={comp} style={{ borderBottom: '1px solid #D8D8D8', fontSize: '12px' }}>{ comp }</Box>) }
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                    }
                                </React.Fragment>
                            )
                        })
                    }

                    <TableRow>
                        <TableCell rowSpan={4} colSpan={2} />
                        <TableCell colSpan={3}>Subtotal</TableCell>
                        <TableCell align="right">{ formatarValor(valorTotalItens) }</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3}>Frete</TableCell>
                        <TableCell align="right">{ formatarValor(valorAdicional) }</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3}>Desconto</TableCell>
                        <TableCell align="right">{ formatarValor(valorTotalDescontosItens) }</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={3}>Total</TableCell>
                        <TableCell align="right">{ formatarValor(valorTotalItens-valorTotalDescontosItens+valorAdicional) }</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default ItensWeb;
